import { ORGANIZATION_API_URLS } from "@/config/apiConfig";
import {
  GetAllOrganizationsResponse,
  CreateOrganizationPayload,
  UpdateOrganizationPayload,
} from "@/types/organization";

// Helper function to get auth token
const getAuthToken = (): string => {
  if (typeof window === "undefined") return "";
  const token = localStorage.getItem("token");
  return token || "";
};

// Get All Organizations
export const getAllOrganizations = async () => {
  const token = getAuthToken();
  const response = await fetch(ORGANIZATION_API_URLS.GET_ALL_ORGANIZATIONS, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  });

  if (!response.ok) throw new Error("Failed to get all organizations");

  const data: GetAllOrganizationsResponse = await response.json();
  console.log("data getAllOrganizations", data);
  return data.data;
};

// Create Organization
export const createOrganization = async (
  organizationData: CreateOrganizationPayload
) => {
  const token = getAuthToken();
  const response = await fetch(ORGANIZATION_API_URLS.CREATE_ORGANIZATION, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify(organizationData),
  });

  if (!response.ok) throw new Error("Failed to create organization");

  const data: any = await response.json();
  return data.data;
};

// Update Organization
export const updateOrganization = async (
  organizationId: string,
  organizationData: UpdateOrganizationPayload
) => {
  const token = getAuthToken();
  const url = ORGANIZATION_API_URLS.UPDATE_ORGANIZATION.replace(
    ":id",
    organizationId
  );

  const response = await fetch(url, {
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify(organizationData),
  });

  if (!response.ok) {
    const errorText = await response.text();
    let errorMessage = "Failed to update organization";
    try {
      const errorData = JSON.parse(errorText);
      errorMessage = errorData.message || errorData.error || errorMessage;
    } catch {
      errorMessage = errorText || errorMessage;
    }
    throw new Error(errorMessage);
  }

  const data: any = await response.json();
  return data.data;
};

// Delete Organization
export const deleteOrganization = async (organizationId: string) => {
  const token = getAuthToken();
  const url = ORGANIZATION_API_URLS.DELETE_ORGANIZATION.replace(
    ":id",
    organizationId
  );
  const response = await fetch(url, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  });

  if (!response.ok) throw new Error("Failed to delete organization");

  const data: any = await response.json();
  return data;
};

// Get Organization By ID
export const getOrganizationById = async (organizationId: string) => {
  const token = getAuthToken();
  const url = ORGANIZATION_API_URLS.GET_ORGANIZATION_BY_ID.replace(
    ":id",
    organizationId
  );
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  });

  if (!response.ok) throw new Error("Failed to get organization by id");

  const data: any = await response.json();
  return data.data;
};
